/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../App.css";
import "./DoubleMatch.css";
import "../../slider.css";
import HeaderBack from "./../../components/Header/HeaderBack";
import Footer from "../../components/Footer/Footer";
import GetFullMatch from "../../components/GetProfile/GetFullMatch.js";
import Popup from "reactjs-popup";
import TimerResponse from "../../components/TimerResponse/TimerResponse";

import axios from "axios";
import { getWordByGender } from "../../handlers/dictionaryHandler.js";
import OpenSentence from "../../components/OpenSentence/OpenSentence.js";

const DoubleMatch = () => {
  const [userName, setUserName] = useState("");
  const [curMatchNew, setCurMatchNew] = useState([]);
  const [openSentence, setOpenSentence] = useState(false);

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [isMsgDisplayed, setIsMsgDisplayed] = useState(true);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/doubleMatchesNew",
        config,
      );
      const userData = response.data.map((curMatchNew) => {
        return {
          match: curMatchNew,
          isOpen: true,
          isFullProfileOpen: false,
        };
      });
      setCurMatchNew([...userData]);
      setIsDataLoaded(true);
      setUserName(userData[0]?.match?.userName || "");
    } catch (error) {
      // probebly user is not authenticated or server is down
    }
  }, []);

  return (
    <form className="double-match-form">
      <HeaderBack />

      <br></br>
      <div className="doublematch-body">
        <div id="h1">ההתאמות שלי ❤️</div>

        <div className="matches-navigation">
          <div className="matches-current">התאמות פעילות</div>

          <Link to="/prevmatches">עוד אפשרויות להכיר</Link>
        </div>
        <p style={{ textAlign: "center", margin: "16px 0" }}>
          כאן מחכות לך ההתאמות הפעילות 💜
          <br />
          אם שניכם תרצו להכיר, תוכלו ליצור קשר!
        </p>

        <Popup
          open={openSentence}
          contentStyle={{
            minWidth: "30%",
            maxWidth: "70%",
            borderRadius: "5px",
          }}
          position="top center"
          onClose={() => setOpenSentence(false)}
          closeOnDocumentClick
          closeOnEscape
        >
          <div
            className="exit-popup"
            onClick={() => {
              setOpenSentence(false);
            }}
          >
            x
          </div>
          <OpenSentence />
        </Popup>

        {isDataLoaded && curMatchNew.length === 0 && (
          <div className="match-card-container">
            <h3 style={{ textAlign: "center" }}>אין כרגע התאמות פעילות 💜</h3>

            <p style={{ textAlign: "center" }}>
              בינתיים אפשר לגלות עוד אפשרויות להכיר!
            </p>

            <div style={{ textAlign: "center" }}>
              <Link to="/prevmatches">לעוד אפשרויות להכיר ←</Link>
            </div>
          </div>
        )}

        {curMatchNew.map((pMatch) => {
          return (
            <div
              key={pMatch.match.MatchId}
              style={{ height: "auto" }}
              className="match-card-container"
            >
              <div
                className="linePlace"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  className="rowTitle"
                  style={{
                    minWidth: "unset",
                  }}
                >
                  {pMatch.match.isEmailSent == 1
                    ? pMatch.match.details + ` ❤️ `
                    : pMatch.match.details}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ marginLeft: "0px" }}>
                    {pMatch.match.isEmailSent == 1 ? (
                      <a
                        href={
                          `https://wa.me/972` +
                          pMatch.match.otherCellular +
                          `?text=הי+${pMatch.match.otherName}+מה+נשמע+זה+${userName}+מדאבל+:)...`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="whatsuplink" />
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className={
                      pMatch.match.isEmailSent == 1 ? "lbl" : "invisible"
                    }
                    onClick={() => setOpenSentence(true)}
                  >
                    {" "}
                    <div
                      style={{
                        textDecoration: "underline",
                        fontWeight: "200",
                      }}
                    >
                      רעיונות למשפטי פתיחה :)
                    </div>
                  </div>
                </div>
              </div>
              <div className="divider" />

              <div id={`prevMatchReportArea` + pMatch.match.MatchId}>
                <GetFullMatch
                  matchId={pMatch.match.MatchId}
                  renewDate={pMatch.match.renewDate}
                  profileTitle={pMatch.match.details}
                />
              </div>
            </div>
          );
        })}
        <br />
        <div
          className="linkToFindPlace shadow"
          // className="popup_lbl lbl_link shadow"
          // style={{ color: "var(--btn-color)", background: "white" }}
        >
          <Link to="/findplace" style={{ textDecoration: "none" }}>
            {"  מקום חדש לדייט הבא שלך – " +
              getWordByGender("come") +
              " לגלות!  ⭐ "}
            {/* <div class="findplaceicon" style={{ marginTop: "-4px" }} /> */}
          </Link>
        </div>

        <br />
        <Link to="/Questionnaires">
          <div
            className="back-link-minimal"
            style={{ display: "block", width: "fit-content", margin: "0 auto" }}
          >
            {" "}
            חזרה
          </div>
        </Link>

        <br />
      </div>
      <Footer />
    </form>
  );
};

export default DoubleMatch;
